import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChurnDetailsModalState = {
  groupId: string | null;
};

const initialState: ChurnDetailsModalState = {
  groupId: null,
};

export const churnDetailsModalSlice = createSlice({
  name: "churnDetailsModal",
  initialState,
  reducers: {
    openChurnDetailsModal: (state, action: PayloadAction<string>) => {
      state.groupId = action.payload;
    },
    closeChurnDetailsModal: (state) => {
      state.groupId = null;
    },
  },
});

export const { openChurnDetailsModal, closeChurnDetailsModal } =
  churnDetailsModalSlice.actions;

export default churnDetailsModalSlice.reducer;
